import { types } from "../actions/types";

const initialState = {
    isAuthenticatedAdmin: false,
    admin: {
        id: 0,
        active: null,
        created: '',
        email: '',
        first_name: '',
        last_name: '',
        modified: '',
        access_token: '',
        users: [],
    },
};


export const authAdminReducer = (state = initialState, action) => {
    switch (action?.type) {
        case types.loginAdmin:
            return {
                isAuthenticatedAdmin: true,
                admin: { ...state.admin, ...action.payload.admin },
            };
        case types.logoutAdmin:
            return {
                isAuthenticatedAdmin: false,
                admin: {},
            };
        default:
            return state;
    }
};
